import api from './axios';

// Get all announcements (public)
export const getAllAnnouncements = async (params = {}) => {
  const response = await api.get('/announcements', { params });
  return response.data;
};

// Get all announcements (admin - includes inactive and expired)
export const getAllAnnouncementsAdmin = async (params = {}) => {
  const response = await api.get('/announcements/admin/all', { params });
  return response.data;
};

// Get announcement types
export const getTypes = async () => {
  const response = await api.get('/announcements/types');
  return response.data;
};

// Get single announcement
export const getAnnouncementById = async (id) => {
  const response = await api.get(`/announcements/${id}`);
  return response.data;
};

// Create announcement
export const createAnnouncement = async (formData) => {
  const response = await api.post('/announcements', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Update announcement
export const updateAnnouncement = async (id, data) => {
  // Check if data is FormData (for multipart updates with new attachment)
  const config = data instanceof FormData ? {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  } : {};
  
  const response = await api.patch(`/announcements/${id}`, data, config);
  return response.data;
};

// Delete announcement
export const deleteAnnouncement = async (id) => {
  const response = await api.delete(`/announcements/${id}`);
  return response.data;
};

// Toggle announcement status
export const toggleAnnouncementStatus = async (id) => {
  const response = await api.patch(`/announcements/${id}/toggle`);
  return response.data;
};

// Bulk delete announcements
export const bulkDeleteAnnouncements = async (ids) => {
  const response = await api.delete('/announcements/bulk/delete', { data: { ids } });
  return response.data;
};
